export function validateEnclosedField(value) {
  const regex = /^\{\{\s*(\S.+?)\s*\}\}$/;
  if (!value) return "Field cannot be empty.";

  if (!regex.test(value.trim())) {
    return "Value must be wrapped with {{ }} and not be empty inside.";
  }
  return "";
}
